import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { WithProjectManagerSideBar } from "src/layouts/ProjectManagerLayout";
import { WithSideBar } from "src/layouts/index,";
import GoodsIn from "src/pages/goodsin";
import DispatchOrders from "src/pages/dispatchOrders";
import { Report } from "src/pages/Report";
import { ItemInventoryReport } from "src/pages/itemInventoryReport";
import { Reconcilition } from "src/pages/reConcilition";
import SearchGoods from "src/pages/searchGoods";
import Admin from "src/pages/admin";
import { Dashboard } from "src/pages/Dashboard/dashboard";
import ProjectManagerDashboard from "src/pages/projectManagerDashboard";
import ProjectManagerGoodsin from "src/pages/projectManagerGoodsin";
import ProjectManagerDispatchOrder from "src/pages/projectManagerDispatch";
import ProjectManagerSearchGoods from "src/pages/projectManagerSearchGoods";
import { getAllLookupData } from "../thunks/lookup";
import { getAllDepots } from "src/thunks/depotUsers";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";

const MainApp = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const Location = useLocation();
  const lookupValues = useSelector((state) => state.lookup);

  /** hooks useState ------------------------------ **/
  const [loading, setLoading] = useState(false);

  /** Variable declarations ------------------------------ **/
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    onUseEffect();
  }, []);

  const onUseEffect = async () => {
    if ((lookupValues?.data)?.length <= 0) {
      await getAllLookupDataCall();
    }
    await getAllDepotsDataFunc();
  };

  /** Retrieve all lookup values ----------------- **/
  const getAllLookupDataCall = async () => {
    try {
      setLoading(true);
      let res = await dispatch(getAllLookupData()).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    } finally {
      setLoading(false);
    }
  };

  /** Retrieve all depots data ----------------------- **/
  const getAllDepotsDataFunc = async () => {
    try {
      setLoading(true);
      let res = await dispatch(getAllDepots()).unwrap();
      setLoading(false);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {userDetails?.roles == "ProjectManager" ? (
        <>
          <WithProjectManagerSideBar>
            <Routes>
              <Route
                path={"/"}
                element={
                  <Navigate replace to={`${Location.pathname}/dashboard`} />
                }
              />
              <Route path={`dashboard`} element={<ProjectManagerDashboard />} />
              <Route path={`goodsin/*`} element={<ProjectManagerGoodsin />} />
              <Route
                path={`dispatchorders/*`}
                element={<ProjectManagerDispatchOrder />}
              />
              <Route path={`report/*`} element={<Report />} />
              <Route path={`iteminventoryreport/*`} element={<ItemInventoryReport />} />
              <Route
                path={`searchgoods/*`}
                element={<ProjectManagerSearchGoods />}
              />
            </Routes>
          </WithProjectManagerSideBar>
        </>
      ) : (
        <>
          <WithSideBar>
            <Routes>
              <Route
                path={"/"}
                element={
                  <Navigate replace to={`${Location.pathname}/dashboard`} />
                }
              />
              <Route path={`dashboard`} element={<Dashboard />} />
              <Route path={`goodsin/*`} element={<GoodsIn />} />
              <Route path={`dispatchorders/*`} element={<DispatchOrders />} />
              <Route path={`report/*`} element={<Report />} />
              <Route path={`iteminventoryreport/*`} element={<ItemInventoryReport />} />
              <Route path={`reconciliation/*`} element={<Reconcilition />} />
              <Route path={`searchgoods/*`} element={<SearchGoods />} />
              <Route path={`admin/*`} element={<Admin />} />
            </Routes>
          </WithSideBar>
        </>
      )}
    </>
  );
};

export default MainApp;
